import { FC, ReactNode, useState } from 'react'
import { MdCategory, MdDownload, MdIosShare, MdSettings } from 'react-icons/md'
import { useTranslation } from 'react-i18next'
import { Sheet } from '../../lib/Types'
import Button from '../Formik/Button'
import Paywall from '../Paywall'
import { SheetType } from './lib/Enums/SheetType'
import { isPaymentOverdue } from './lib/Payment'
import TrialEndedPaywallContent from './TrialEndedPaywallContent'

interface Props {
  sheet: Sheet
  title?: string
  icon: string
  onClick: () => any
  children?: ReactNode
  // Forces the paywall regardless of payment/trial status — e.g. a premium
  // action that stays locked on a permanently free budget.
  locked?: boolean
}

const MenuButton: FC<Props> = ({
  sheet,
  title,
  icon,
  onClick,
  children,
  locked,
}) => {
  const { t } = useTranslation(['configuration', 'common'])
  const [showPaywall, togglePaywall] = useState(false)
  const genericName =
    sheet.sheet_type === SheetType.BUDGET
      ? t('common:paywall.budget')
      : sheet.sheet_type === SheetType.SPREADSHEET
        ? t('common:paywall.spreadsheet')
        : t('common:paywall.accounting')

  const action = () => {
    if (locked || isPaymentOverdue(sheet)) {
      togglePaywall(true)
    } else {
      onClick()
    }
  }

  return (
    <>
      <Button
        theme='gray'
        tooltip={t('configuration:menuButton.tooltip')}
        className='ml-2'
        onClick={action}
      >
        <div className='flex'>
          {icon === 'MdShare' && <MdIosShare size='1.25rem' />}
          {icon === 'MdCategory' && <MdCategory size='1.25rem' />}
          {icon === 'MdSettings' && <MdSettings size='1.25rem' />}
          {icon === 'MdDownload' && <MdDownload size='1.25rem' />}
          {title && <span className='ml-2'>{title}</span>}
        </div>
      </Button>
      <Paywall
        show={showPaywall}
        onHide={() => togglePaywall(false)}
        sheetType={sheet.sheet_type}
        sheetId={sheet.id}
        name={sheet.name || genericName}
      >
        {children || <TrialEndedPaywallContent sheet={sheet} />}
      </Paywall>
    </>
  )
}

export default MenuButton
